module.exports = __webpack_public_path__ + "img/audioGradient.fbd1ef61.svg";